import { Component,OnInit} from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { Router } from '@angular/router';
import { GraphqlService } from '../../common/services/graphql.service';

@Component({
  selector: 'app-pending-content-agreement',
  templateUrl: './pending-content-agreement.component.html'
})
export class PendingContentAgreementComponent implements OnInit {

  constructor(
    private route: Router,
    private commonDataService: CommonDataService,
    private graphQlService: GraphqlService
  ) { }
  generalFeedback: any = "General Feedback"
  pc_header;
  pc_agree;
  pc_decline;
  pc_agreementText;
  pc_tclink;
  pc_termsandcondition;
  indexoftandc;
  content1TC;
  content2TC;
  content3TC;
  isagreed: boolean = false;
  userId: string = "";

  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.getpendingcontentsystemLabel();
   
  }

  getpendingcontentsystemLabel() {
    this.graphQlService.getPendingContentSystemLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.pc_header = labels.filter(x => x.key == "pc_header").map(y => y.value);
        this.pc_agreementText = labels.filter(x => x.key == "pc_agreementText").map(y => y.value);
        this.pc_decline = labels.filter(x => x.key == "pc_decline").map(y => y.value);
        this.pc_agree = labels.filter(x => x.key == "pc_agree").map(y => y.value);
        this.content1TC = this.pc_agreementText[0].split("[Terms_And_Condition]")[0]
        this.content2TC = labels.filter(x => x.key == "pc_terms").map(y => y.value);
        this.content3TC = this.pc_agreementText[0].split("[Terms_And_Condition]")[1]
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

  showTC() {
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightOverlayOption.next("Terms And Conditions");
    this.commonDataService.rightPanelWidth.next("rightOverlay_large");
    this.commonDataService.tcsource.next("pendingcontentsystem");
    this.commonDataService.closeModalOption.next(true);
  }

  homepageredirect() {
    this.route.navigateByUrl("/Home");
  }
  acceptTC() {
    this.graphQlService.SetPendingContentAgreementSession(true).subscribe(data => {
      this.route.navigate(['pendingcontentsystem']);
    });
  }
}
